import { Injectable } from '@angular/core';
import { LiteratureDataService } from '@literature/services/literature-data.service';
import { MailFormValues, MailResponseObject, MailResponseError } from '@types';

@Injectable({
  providedIn: 'root',
})
export class LiteratureYourCartOrderSuccessService {
  constructor(private literatureDataService: LiteratureDataService) {}

  getMailFormValue(): MailFormValues {
    return this.literatureDataService.getMailDetails();
  }

  postMailResponse(): MailResponseObject {
    return this.literatureDataService.getPostMailResponse();
  }
  postMailError(): MailResponseError {
    return this.literatureDataService.getPostMailError();
  }
}
